/**
 * Cliente API de la carga inicial pre-LIVE de recursos (Sprint 19 S19-B4).
 *
 * Solo super_admin. Mismo patrón que `import_pagos_iniciales`: se envía el
 * CSV crudo (`csv_contenido`) y el backend parsea; `dry_run` valida y reporta
 * sin persistir. Endpoints en `apps/backend/app/api/cargas.py`.
 */
import { apiFetch } from './client';

export interface FilaResultado {
  fila: number;
  referencia: string;
  casa: string;
  resultado: 'creado' | 'omitido' | 'error';
  detalle: string | null;
}

export interface CargaResultado {
  modo: 'dry_run' | 'real';
  total: number;
  creados: number;
  omitidos: number;
  errores: number;
  filas: FilaResultado[];
}

export interface CargaCsvPayload {
  csv_contenido: string;
  dry_run?: boolean;
}

export function cargarLlaverosCsv(
  payload: CargaCsvPayload,
): Promise<CargaResultado> {
  return apiFetch<CargaResultado>('/sa/cargas/llaveros-csv', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function cargarControlesCsv(
  payload: CargaCsvPayload,
): Promise<CargaResultado> {
  return apiFetch<CargaResultado>('/sa/cargas/controles-remotos-csv', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export interface SaldoAperturaResultado {
  id: string;
  anio: number;
  saldo_final_banco: number | null;
  total_lotes_con_saldo: number;
  total_saldo_arrastrado: number;
}

/**
 * Siembra el saldo de apertura del barrio: crea el cierre anual de `anio`
 * (el año anterior al go-live) con su saldo bancario. Carga inicial
 * one-time. 409 si ya existe un cierre para ese año.
 */
export function sembrarSaldoApertura(
  anio: number,
  saldoFinalBanco: number,
): Promise<SaldoAperturaResultado> {
  return apiFetch<SaldoAperturaResultado>('/sa/cargas/saldo-apertura', {
    method: 'POST',
    body: JSON.stringify({ anio, saldo_final_banco: saldoFinalBanco }),
  });
}
